export default __webpack_public_path__ + "static/media/Awards_BG-02.0f1c086b.png";